var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("collapsible-card", {
    ref: "collapseCustomFields",
    attrs: {
      "collapse-id": "custom-fields-card",
      "store-path": "customFields",
    },
    on: { hidden: _vm.resetCustomFieldsView },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function (ref) {
          var collapsed = ref.collapsed
          return [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("global.doorr.additionalFields"))),
            ]),
            _vm._v(" "),
            !collapsed
              ? _c(
                  "div",
                  { staticClass: "coapp-actions d-flex align-items-center" },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "clickable mr-2",
                        attrs: {
                          "data-toggle": "tooltip",
                          "data-original-title": _vm.editTooltipText,
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-cog",
                          class: { disabled: !_vm.canManageCustomFields },
                          attrs: { "aria-hidden": "true" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              return _vm.toggleEditing()
                            },
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "clickable",
                        attrs: {
                          "data-toggle": "tooltip",
                          "data-original-title": _vm.createTooltipText,
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-plus text-primary",
                          class: { disabled: !_vm.canManageCustomFields },
                          attrs: { "aria-hidden": "true" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              return _vm.toggleCreating()
                            },
                          },
                        }),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
          ]
        },
      },
      {
        key: "body",
        fn: function () {
          return [
            _vm.loading
              ? _c("custom-fields-loader")
              : [
                  _vm.showCustomDataFieldsForm
                    ? _c("custom-data-fields-form", {
                        attrs: {
                          value: _vm.customFields,
                          "board-id": _vm.boardId,
                          "custom-fields-definitions":
                            _vm.customFieldsDefinitions.byId,
                          "translation-map": _vm.CUSTOM_FIELDS_TRANSLATION_MAP(
                            _vm.boardId
                          ),
                        },
                        on: {
                          change: _vm.handleCustomFieldDataChange,
                          submit: _vm.saveOnType,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.canManageCustomFields
                    ? [
                        _c(
                          "div",
                          { staticClass: "row" },
                          [
                            _vm.creating
                              ? _c("create-custom-field-form", {
                                  ref: "createCustomFieldForm",
                                  on: {
                                    hide: function ($event) {
                                      return _vm.toggleCreating(false)
                                    },
                                    submit: _vm.handleCreate,
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.editing && !_vm.currentEditingField
                          ? _c("edit-fields-definitions-form", {
                              attrs: {
                                "custom-fields": _vm.customFields,
                                "custom-fields-definitions":
                                  _vm.customFieldsDefinitions,
                              },
                              on: {
                                create: function ($event) {
                                  return _vm.toggleCreating(true)
                                },
                                edit: _vm.toggleEditField,
                                cancel: function ($event) {
                                  return _vm.toggleEditing(false)
                                },
                                delete: _vm.handleDelete,
                                order: _vm.handleOrder,
                                visibility: _vm.handleVisibilityToggle,
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.currentEditingField
                          ? _c(
                              "div",
                              { staticClass: "row" },
                              [
                                _c("create-custom-field-form", {
                                  ref: "createCustomFieldForm",
                                  attrs: { value: _vm.currentEditingField },
                                  on: {
                                    hide: function ($event) {
                                      return _vm.toggleEditField(null)
                                    },
                                    submit: _vm.handleEdit,
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    : _vm._e(),
                ],
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }